/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
  {
    path: '/ap/:id/:status?',
    // Relative to /src/views
    meta: { layout: 'public' },
    view: 'public/cm-payments/Index'
  },
  {
    path: '/login',
    // Relative to /src/views
    meta: { layout: 'public' },
    view: 'private/Login'
  },
  {
    path: '/dashboard',
    name: 'path.dashboard.title',
    meta: { layout: 'private', requiresAuth: true },
    view: 'private/dashboard/Index'
  },
  // ADMIN USER
  {
    path: '/',
    name: 'dashboard.title',
    meta: { layout: 'private', requiresAuth: true },
    view: 'private/dashboard/Index'
  },
  {
    path: '/users',
    name: 'users.title',
    meta: { layout: 'private', requiresAuth: true },
    view: 'private/users/Index'
  },
  {
    path: '/users/:id',
    name: 'users.userTitle',
    meta: { layout: 'private', requiresAuth: true },
    view: 'private/users/User'
  },
  {
    path: '/enterprises',
    name: 'enterprises.title',
    meta: { layout: 'private', requiresAuth: true },
    view: 'private/enterprises/Index'
  },
  {
    path: '/enterprises/:id',
    name: 'enterprises.enterpriseTitle',
    meta: { layout: 'private', requiresAuth: true },
    view: 'private/enterprises/Enterprise'
  },
  {
    path: '/fcovid',
    name: 'rcovid.title',
    meta: { layout: 'private', requiresAuth: true },
    view: 'private/rcovid/Index'
  },
  {
    path: '/custom-forms',
    name: 'formCio.title',
    meta: { layout: 'private', requiresAuth: true },
    view: 'private/formCio/Index'
  },
  {
    path: '/dishes',
    name: 'dishes.title',
    meta: { layout: 'private', requiresAuth: true },
    view: 'private/dishes/Index'
  },
  {
    path: '/products',
    name: 'products.title',
    meta: { layout: 'private', requiresAuth: true },
    view: 'private/products/Index'
  },
  // NORMAL USER
  {
    path: '/settings',
    name: 'settings.title',
    meta: { layout: 'private', requiresAuth: true },
    view: 'private/settings/Index'
  },
  {
    path: '/menus',
    name: 'menus.title',
    meta: { layout: 'private', requiresAuth: true },
    view: 'private/menus/Index'
  },
  {
    path: '/menus/:id',
    name: 'menus.menu',
    meta: { layout: 'private', requiresAuth: true },
    view: 'private/menus/Index'
  },
  {
    path: '/share',
    name: 'share.title',
    meta: { layout: 'private', requiresAuth: true },
    view: 'private/share/Index'
  },
  {
    path: '/common-menus',
    name: 'commonMenus.title',
    meta: { layout: 'private', requiresAuth: true },
    view: 'private/menus/Index'
  },
  {
    path: '/enterprises/common-menus/:id',
    name: 'commonMenus.commonMenu',
    meta: { layout: 'private', requiresAuth: true },
    view: 'private/enterprises/commonMenus/Index'
  },
  {
    path: '/poll',
    name: 'poll.title',
    meta: { layout: 'private', requiresAuth: true },
    view: 'private/poll/Index'
  },
  {
    path: '/dish-orders',
    name: 'dish-order.title',
    meta: { layout: 'private', requiresAuth: true },
    view: 'private/dishOrders/Index'
  },
  {
    path: '/dish-orders/:id',
    name: 'dish-order.title',
    meta: { layout: 'private', requiresAuth: true },
    view: 'private/dishOrders/Index'
  },
  {
    path: '/dish-orders-points',
    name: 'dish-order.points.title',
    meta: { layout: 'private', requiresAuth: true },
    view: 'private/dishOrders/points/Index'
  },
  {
    path: '/welcome-form',
    name: 'welcomeForm.title',
    meta: { layout: 'private', requiresAuth: true },
    view: 'private/welcomeForm/Index'
  },



  //   path: '/users',
  //   name: 'path.users.title',
  //   meta: { layout: 'private', requiresAuth: true },
  //   view: 'private/users/Index'
  // },
  // {
  //   path: '/settings',
  //   name: 'path.settings.title',
  //   meta: { layout: 'private', requiresAuth: true },
  //   view: 'private/settings/Index'
  // },
  // {
  //   path: '/test',
  //   name: 'path.share.title',
  //   meta: { layout: 'private', requiresAuth: true },
  //   view: 'private/Test'
  // },
  // {
  //   path: '/user-profile',
  //   name: 'User Profile',
  //   meta: { layout: 'private', requiresAuth: true },
  //   view: 'private/UserProfile'
  // },
  // {
  //   path: '/table-list',
  //   name: 'Table List',
  //   meta: { layout: 'private', requiresAuth: true },
  //   view: 'private/TableList'
  // },
  // {
  //   path: '/typography',
  //   meta: { layout: 'private', requiresAuth: true },
  //   view: 'private/Typography'
  // },
  // {
  //   path: '/icons',
  //   meta: { layout: 'private', requiresAuth: true },
  //   view: 'private/Icons'
  // },
  // {
  //   path: '/maps',
  //   meta: { layout: 'private', requiresAuth: true },
  //   view: 'private/Maps'
  // },
  // {
  //   path: '/notifications',
  //   meta: { layout: 'private', requiresAuth: true },
  //   view: 'private/Notifications'
  // },
  // {
  //   path: '/upgrade',
  //   meta: { layout: 'private', requiresAuth: true },
  //   name: 'Upgrade to PRO',
  //   view: 'private/Upgrade'
  // },
  {
    path: '*',
    // Relative to /src/views
    meta: { layout: 'private', requiresAuth: true },
    view: '404'
  }
]
